import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { LandingPage } from "./components/landingPage";
import { FeaturesPage } from "./components/featuresPage";
import { AboutPage } from "./components/aboutPage";
import { Layout } from "./components/layout";

// Create the router with the future flag enabled
const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { path: "/", element: <LandingPage /> },
        { path: "/features", element: <FeaturesPage /> },
        { path: "/about", element: <AboutPage /> },
        { path: "*", element: <Navigate to="/" /> },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
    },
  }
);

function App() {
  if (process.env.NODE_ENV === "production") {
    // Disable console warnings and errors in production
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
  }
  return <RouterProvider router={router} />;
}

export default App;
